module.exports = __webpack_public_path__ + "components/incentive/static/unlock-af897bd48b1c84df8d4fb9cc259ff102.png";